export default "__VITE_ASSET__BRPS$B3a__"